/**
 * Configuration for the application watermark.
 * @module Watermark
 * 
 */

/**
 * Watermark settings including developer signature.
 */
const watermark = {
  /** The developer handle used in responses. */
  dev: "@prm2.0"
};

export default watermark;
